export const ENC_MASK = "enc:********";
export const SECRET_AUTO_HIDE_MS = 30000;
